export const MRI_VAULT_CRM_EMAIL_TEMPLATE = {
  to: 'support@mri.com',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - MRI Vault CRM Setup',
  body: `Hello MRI Vault CRM

Could you please enable Snug as an upload destination for our agency for the MRI Vault CRM Account(s):

- [Enter your Agency ID here]

Please assign the MRI Vault CRM Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
